import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetPatientStatusDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useConfirmPatientStatus = (patientId: string) => {
  const [getPatient, { data, loading }] = useLazyQuery(GetPatientStatusDocument);
  const isActivePatient = !!getNode(data, 'Patient')?.active;

  useEffect(() => {
    if (patientId) {
      getPatient({ variables: { patientId } });
    }
  }, [getPatient, patientId]);

  return { isActivePatient, loading };
};
